/* unplugin-vue-components disabled */import script from "./SectsSkillPreviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SectsSkillPreviewCard.vue?vue&type=script&setup=true&lang=js"

import "./SectsSkillPreviewCard.vue?vue&type=style&index=0&id=eb79ff30&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb79ff30"]])

export default __exports__